<template>
    <v-dialog 
        :value="value" 
        @input="$emit('input', $event)" 
        max-width="520" 
        persistent
        content-class="welcome-modal-dialog"
    >
        <v-card class="welcome-modal-card">
            <v-card-text class="pa-0">
                <!-- Decorative Header -->
                <div class="welcome-header">
                    <div class="welcome-pattern"></div>
                    <div class="welcome-icon-container">
                        <div class="welcome-icon">
                            <v-icon size="48" color="white">mdi-book-open-page-variant</v-icon>
                        </div>
                    </div>
                </div>

                <!-- Content -->
                <div class="welcome-content">
                    <h2 class="welcome-title">Welcome to Riwaq Al-Quran!</h2>
                    <p class="welcome-subtitle">Assalamu Alaikum {{ userName }}</p>
                    
                    <p class="welcome-description">
                        We're excited to have you join our community of learners. 
                        Let us give you a quick tour to help you get started on your journey.
                    </p>

                    <div class="welcome-features">
                        <div class="feature-item">
                            <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                            <span>Explore our course catalog</span>
                        </div>
                        <div class="feature-item">
                            <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                            <span>Learn how to navigate the platform</span>
                        </div>
                        <div class="feature-item">
                            <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                            <span>Get support when you need it</span>
                        </div>
                    </div>

                    <div class="welcome-actions">
                        <v-btn 
                            color="primary" 
                            depressed 
                            large 
                            class="start-tour-btn"
                            @click="$emit('start-tour')"
                        >
                            <span>Start Tour</span>
                            <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-btn 
                            text 
                            color="grey darken-1" 
                            class="skip-btn"
                            @click="$emit('skip-tour')"
                        >
                            Skip for now
                        </v-btn>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'WelcomeTourModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        userName: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.welcome-modal-card {
    border-radius: 16px !important;
    overflow: hidden;
}

.welcome-header {
    background: linear-gradient(135deg, #994C26 0%, #732E0B 100%);
    height: 140px;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.welcome-pattern {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
}

.welcome-icon-container {
    position: relative;
    transform: translateY(50%);
    z-index: 1;
}

.welcome-icon {
    width: 88px;
    height: 88px;
    background: linear-gradient(135deg, #E79007 0%, #d18306 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(231, 144, 7, 0.35);
    border: 4px solid white;
}

.welcome-content {
    padding: 60px 32px 32px;
    text-align: center;
}

.welcome-title {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 24px;
    color: #1E1E1E;
    margin-bottom: 8px;
}

.welcome-subtitle {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #994C26;
    margin-bottom: 16px;
}

.welcome-description {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: rgba(30, 30, 30, 0.7);
    line-height: 1.6;
    margin-bottom: 24px;
}

.welcome-features {
    text-align: left;
    background: #FAFAFA;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 24px;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: #1E1E1E;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }
}

.welcome-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.start-tour-btn {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.3px;
    height: 48px !important;
    border-radius: 8px;
}

.skip-btn {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
}
</style>

